import { LocalStorageService } from '@/services';
import { LOCAL_STORAGE_KEYS } from '@/constants';

interface userDataTypes {
	ip: string;
	city: string;
	postal_code: string;
	country_code: string;
	subdivision: string;
}

const initialUserData = {
	ip: '',
	city: '',
	postal_code: '',
	country_code: '',
	subdivision: '',
};

export const getUserDataFromLocalStorage = () => {
	const userData = LocalStorageService.get<userDataTypes>(
		LOCAL_STORAGE_KEYS.USER_DATA,
		initialUserData,
	);

	return {
		ip: userData.ip,
		city: userData.city,
		zipCode: userData.postal_code,
		countryCode: userData.country_code,
		subdivision: userData.subdivision,
	};
};
